module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dlix5"))).then(() => parcelRequire('5erN3'));